export type ApiErrorKind =
  'validation' | 'unauthorized' | 'forbidden' | 'not_found' | 'conflict' | 'rate_limited' | 'server' | 'network';

function kindFromStatus(status: number): ApiErrorKind {
  if (status === 400 || status === 422) return 'validation';
  if (status === 401) return 'unauthorized';
  if (status === 403) return 'forbidden';
  if (status === 404) return 'not_found';
  if (status === 409) return 'conflict';
  if (status === 429) return 'rate_limited';
  return 'server';
}

export class ApiError extends Error {
  readonly kind: ApiErrorKind;
  readonly status: number;
  readonly code?: string;

  constructor(message: string, status: number, kind?: ApiErrorKind, code?: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.kind = kind ?? kindFromStatus(status);
    this.code = code;
  }

  static network(message = 'Не удалось связаться с сервером. Проверьте подключение и повторите попытку.',
  ): ApiError {
    return new ApiError(message, 0, 'network');
  }
}